import { createAction, props } from '@ngrx/store';

export const setPrsPermissions = createAction('[PRS] Set PRS permissions', props<{ prsPermissions: FixMeAny }>());
